import AccountSettings from './components/AccountSettings';
import Form from './components/Form';
import FormPremium from './components/FormPremium';
import React from 'react';
import './App.css';

function App(props) {
  const { member: formType, context, role } = props.instanceElement.dataset;
  return (
    <>
      {
        context === 'account-settings' ? (<AccountSettings role={role} context={context} />) : (
          formType === 'basic' ? <Form /> : <FormPremium context={context} />
        )
      }
    </>
  )
}

export default App
